/**
 * An event type's form rules, in one place (DESIGN_SYSTEM.md §9 "One field,
 * one control"). Mirrors api/src/tags.ts: name and slug are required after
 * trimming, and the slug is at most 100 characters. The API only trims the
 * slug — it does not lowercase it — so the form never rewrites what was typed.
 */
export const TAG_SLUG_MAX_LENGTH = 100;

export const TAG_SLUG_HELP = 'The identifier subscriptions and processors use for this event type.';

export type TagFieldErrors = {
  name?: string;
  slug?: string;
  parentId?: string;
};

export function validateTagDraft(draft: { name: string; slug: string }): TagFieldErrors {
  const errors: TagFieldErrors = {};
  if (!draft.name.trim()) errors.name = 'Name is required.';
  const slug = draft.slug.trim();
  if (!slug) errors.slug = 'Slug is required.';
  else if (slug.length > TAG_SLUG_MAX_LENGTH) errors.slug = `Slug must be ${TAG_SLUG_MAX_LENGTH} characters or fewer.`;
  return errors;
}

/** The stored slug when it differs from what was typed (surrounding spaces), else null. */
export function resolvedTagSlug(typed: string): string | null {
  const trimmed = typed.trim();
  return trimmed !== '' && trimmed !== typed ? trimmed : null;
}
